import { TFunction } from 'i18next';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Template, Theme } from '../enums';
import { PageModeContext } from './PageMode/PageMode.provider';

interface ProviderProps {
  children({
    themeName,
    templateName,
    t,
  }: {
    themeName: Theme;
    templateName: Template;
    t: TFunction;
  }): React.ReactNode;
}

export const UiProvider: React.FC<ProviderProps> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <PageModeContext.Consumer>
      {({ theme, template }) =>
        children({
          t,
          themeName: theme,
          templateName: template,
        })
      }
    </PageModeContext.Consumer>
  );
};
